import { z } from "zod";

// Admin-driven user creation -- creates account + assigns role
export const createUserSchema = z.object({
  email: z.string().email("Valid email is required").transform((v) => v.toLowerCase()),
  first_name: z.string().min(1, "First name is required").max(100),
  last_name: z.string().min(1, "Last name is required").max(100),
  role_type: z.enum([
    "super_admin",
    "org_admin",
    "school_admin",
    "coach",
    "super_parent",
    "parent",
    "player",
    "sponsor_admin",
    "sponsor_user",
  ]),
  scope_type: z.enum(["platform", "organization", "school", "sponsor"]),
  scope_id: z.string().min(1, "Scope ID is required"),
});

export type CreateUserInput = z.infer<typeof createUserSchema>;

// Update user profile (name only -- email changes are more sensitive)
export const updateUserSchema = z.object({
  first_name: z.string().min(1, "First name is required").max(100),
  last_name: z.string().min(1, "Last name is required").max(100),
});

export type UpdateUserInput = z.infer<typeof updateUserSchema>;
